// extracted by mini-css-extract-plugin
export default {"purchase-preview":"purchase_purchase-preview__mZpKQ","truncate":"purchase_truncate__9Y75f","withdrawals-link":"purchase_withdrawals-link__I6HPk"};